import React from 'react';
import { TextField } from '@mui/material';

export default function ProjectSecretNameField({
  mode,
  value,
  onChange,
  error,
  helper_text,
}) {
  const is_edit = mode === 'edit';

  return (
    <TextField
      fullWidth
      margin='normal'
      label='Name'
      value={value}
      onChange={onChange}
      disabled={is_edit}
      error={error}
      helper_text={helper_text}
      autoComplete='off'
    />
  );
}
